import {keys} from 'ts-transformer-keys';
import {DataObjects} from '~/shared/src/utilities/action';


export type MessageObject = {
    id : number;
    key : string;
    name : string;

    content? : { [ key : string ] : string; };
    dataObjects : DataObjects;
};
export const messageObjectProps = keys<MessageObject>();
export const requiredMessageObjectProps = keys<RequiredOf<MessageObject>>();

export type Message = string | MessageObject;
